/**
 * zLayers.js — WHAT MAY SIT ON TOP OF WHAT.
 * v242.173.0 · BUILD123-REINSTATE-1 (1 of 3), LOCKSCREEN-UNDER-CHAT-1
 *
 * ★★★ HIS REPORT, 2026-08-22: "when the app idles and the pin screen come on, the orella
 * pop up chat is outside of that! need to be hidden within the security screen."
 * v242.123.0 fixed it and was withdrawn whole during the DELIVER-AGENT-OPENER-2 revert
 * chain, for a defect in a different file. Reinstated here, one of three, on his ruling
 * of 2026-09-08 that the lock screen goes first.
 *
 * ★★★ IT WAS A TIE, AND A TIE IS BROKEN BY DOCUMENT ORDER. The chat sheet and the PIN
 * lock were BOTH `z-[9999]`, and both portal to <body>, so which one covered the other
 * depended on which happened to mount last. Session 87's OverlayPortal sweep (D408) gave
 * the lock a portal, which makes it usually win — and "usually", decided by mount order,
 * is not a security property.
 *
 * ★★★ AND RE-MEASURING FOUND THE REPORTED CHAT WAS NOT THE WORST OF IT. Census taken
 * 2026-09-08, every z-index in src/ at or above the lock's tier:
 *     100000  WheelPicker
 *      99999  PrivacyScreen · CardScanner ×2 · ProfileMedications ×2
 *      10000  SharePassModal · WalletPassModal
 *       9999  the PIN lock — and TWENTY-TWO other overlays tied with it
 * So the medication sheet, the medication confirm dialog and the insurance-card scanner
 * — three screens whose entire content is PHI — rendered ABOVE the PIN screen outright,
 * with no tie to break. The chat was the one he happened to see.
 *
 * ★★ THE TIERS ARE ORDERS OF MAGNITUDE APART ON PURPOSE. Adjacent numbers invite the next
 * author to add one; a gap says the tiers are a decision, not a queue.
 *
 * ★★★ AND RAISING THE TIER IS ONLY HALF THE FIX. A covered sheet is still in the DOM,
 * still reachable by assistive tech, and still there to flash back the instant the PIN is
 * accepted. `GlobalAgentProvider` closes the agent when `isLocked` goes true.
 * COVERING PHI IS NOT PUTTING IT AWAY, and that is the half that matters.
 *
 * ★ No imports: `scripts/check-security-tier.mjs` loads this in node.
 */

/** Ordinary overlays: sheets, modals, dialogs. The floor everything shares. */
export const Z_SHEET = 9999

/** Overlays that must sit above a sheet because a sheet opened them — pickers, scanners. */
export const Z_ELEVATED = 100000

/**
 * Security. The PIN lock, the idle warning and the privacy screen — and, since PROD-349
 * (2026-09-30), the 911 sheet in Emergency.jsx. That fourth one is not a privacy or lock
 * surface: it is the clinical escape hatch ("Call 911"), it shows no PHI, and no ordinary
 * sheet may cover it. It reaches the tier by this NAME and is portalled to <body>.
 * ★ It TIES with the PIN lock rather than out-ranking it, so between those two the later
 *   mount wins (document order). Nothing here decides which of the two should win.
 * ★★★ NOTHING IN THIS APP MAY RENDER AT OR ABOVE THIS NUMBER except those four, and only
 *   through this name. That is not a style rule: anything that outranks the lock screen is,
 *   by construction, PHI a locked session is still showing. `check-security-tier.mjs` fails
 *   the build on a literal at or above it (ARM 1) and requires the four to use it (ARM 2).
 */
export const Z_SECURITY = 2000000
